import CareerApi from "../../services/api/CareersApi.js";
import Vue from "vue";

const CareerApiService = new CareerApi();

export default {
  data() {
    return {
      jobs: [],
    };
  },

  methods: {
    togglePreview: togglePreview,
    applyForJob: applyForJob,
    getJobs: getJobs,
  },

  beforeMount() {
    this.getJobs();
  },
};

function togglePreview(index) {
  Vue.set(this.jobs[index], "previewActive", !this.jobs[index].previewActive);
}

function applyForJob(id) {
  this.$router.push({ path: "/career-form/" + id });
}

function getJobs() {
  CareerApiService.getJobs()
    .then((response) => {
      var jobs = response.data.records,
        parsed = [];

      for (var i = 0; i < jobs.length; i++) {
        if (Object.keys(jobs[i].fields).length !== 0 && jobs[i].fields.Active === "true") {
          var job = jobs[i].fields;

          var descriptionString = job["Application page - Long Description"].split("|");
          job.Description = descriptionString;
          job.id = jobs[i].id;

          parsed.push(job);
        }
      }

      this.jobs = parsed;
    })
    .catch((error) => {
      this.$swal("Attention", error);
    });
}
